<template>
    <a href="javascript:void(0)" class="dropdown-toggle nk-quick-nav-icon" data-bs-toggle="dropdown" @click="markRead(false)">
        <div v-bind:class="notifStatus ? 'icon-status icon-status-info' : ''">
            <em class="icon ni ni-bell"></em>
        </div>
    </a>
    <div class="dropdown-menu dropdown-menu-xl dropdown-menu-right dropdown-menu-s1">
        <div class="dropdown-head">
            <span class="sub-title nk-dropdown-title">My Notifications  <span class="badge rounded-pill bg-primary">{{ notifications.length ?? 0 }}</span></span>
            <!-- <a href="#" @click="markRead">Mark All as Read</a> -->
        </div>
        <div class="dropdown-body">
            <div class="nk-notification">

                <a class="nk-notification-item dropdown-inner" v-for="(notification, index) in notifications" :href="notification.data.action.params.url">
                    <div class="nk-notification-icon">
                        <em v-bind:class="iconClass(notification.type)"></em>
                    </div>
                    <div class="nk-notification-content">
                        <div class="nk-notification-text">
                            {{ notification.title }}
                            <p v-html="notification.data.description"></p>
                        </div>
                        <div class="nk-notification-time">
                            {{ frontEndDateFormat(notification.created_at) }}
                        </div>
                    </div>
                </a>

            </div>
        </div>
        <div class="dropdown-foot center">
            <a href="/system/profile/notifications">Go to My Notifications</a>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Swal from 'sweetalert2';

export default {
    name: "Notification",
    methods: {
        frontEndDateFormat: function(date) {
            return moment(date).fromNow();
        },
        iconClass: function (type) {
            switch (type) {
                case 'info':
                    return 'icon icon-circle bg-info-dim ni ni-info'
                case 'warning':
                    return 'icon icon-circle bg-warning-dim ni ni-curve-down-right'
                default:
                    return 'icon icon-circle bg-warning-dim ni ni-curve-down-right'
            }
        },
        markRead(notif = true) {
            if(this.notifications.length == 0) return
            axios.get('/system/notifications/mark-read')
                .then(response => {
                    if(notif)
                    {
                        Swal.fire({
                            icon: 'success',
                            title: 'Success!',
                            text: 'All data was marked read successfully',
                        });
                    }

                    this.notifStatus = false
                })
                .catch(error => {
                    // Handle the error response
                    console.error('Error deleting data:', error);
                });
        }
    },

    data() {
        return {
            notifications: [],
            notifStatus: false,
        };

    },

    created() {
        axios.get('/system/notifications')
            .then(response => {
                // console.log(response);
                this.notifications = response.data.data;
                this.notifStatus = this.notifications.length ? true : false
            })
            .catch(function (error) {
                console.log(error);
            });
    }

}
</script>

<style scoped>

</style>
